/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_eiybyVKiY",
    "aws_user_pools_web_client_id": "1trr277lg8oc7cd4cpin1a4f1a",
    "oauth": {}
};


export default awsmobile;
